import { render, staticRenderFns } from "./PartSupplierInput.vue?vue&type=template&id=46c5dab2&"
import script from "./PartSupplierInput.vue?vue&type=script&lang=js&"
export * from "./PartSupplierInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports